module.exports = __webpack_public_path__ + "img/gh-30282-2-56.prt.9a9173ef.jpg";